export default function serializeAttachment(data) {
  return {
    id: data.id,
    file: data.file,
    name: data.name,
    _destroy: data._destroy,
  };
}



// WEBPACK FOOTER //
// ./src/lib/utils/api/serializers/serializeAttachment.js